import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import VueMeta from 'vue-meta';
import VueGtm from '@gtm-support/vue2-gtm';
import Hotjar from 'vue-hotjar';
import App from './App.vue';
import router from './router/index.js';
import store from './store/index.js';

import '~/bootstrap/scss/bootstrap.scss';
import '~/bootstrap-vue/src/index.scss';

Vue.use(BootstrapVue);
Vue.use(VueMeta);

if (process.env.VUE_APP_ENVIRONMENT === 'PRD') {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_TAG_MANAGER,
    debug: false,
    vueRouter: router,
  });

  Vue.use(Hotjar, { id: process.env.VUE_APP_HOTJAR });
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
